import { render, staticRenderFns } from "./duhaicao-carousel.vue?vue&type=template&id=3e7bc468&scoped=true"
import script from "./duhaicao-carousel.vue?vue&type=script&lang=js"
export * from "./duhaicao-carousel.vue?vue&type=script&lang=js"
import style0 from "./duhaicao-carousel.vue?vue&type=style&index=0&id=3e7bc468&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7bc468",
  null
  
)

export default component.exports